import type { BannerV2Content } from '@/core/types';

import { BannerV2 } from '@/containers/blocks/banners';

export default function generate({
  content,
  className,
}: {
  content: BannerV2Content;
  className?: string;
}) {
  return (
    <BannerV2
      title={content.title}
      titleTag={content.titleTag}
      description={content.description}
      image={content.image}
      className={className}
      buttons={content.buttons}
    />
  );
}
